import { createContext, useContext, useEffect, useState } from "react";
import { useIdAndStateContext } from "providers/IdAndState.provider";
import axios, { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";

export interface PlayerConfigContextType {
  data: any;  // Remplace `any` par le type de tes données
  isLoading: boolean;
}

const PlayerConfigContext = createContext<PlayerConfigContextType | undefined>(undefined);

export const usePlayerConfigContext = () => {
  const context = useContext(PlayerConfigContext);
  if (!context) {
    throw new Error('useDataContext must be used within a DataProvider');
  }
  return context;
};

export const PlayerConfigProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [data, setData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const {id, state } = useIdAndStateContext();


  useEffect(() => {
    axios.get(
      `${window.runtime.api_endpoint}/res/shares/${id}.json`,
      {headers: {'WWW-Authenticate': state?.password ?? null}}
    ).then((res) => {
      setData(res.data.data);
      setIsLoading(false);
      // dispatch(initPlayer(res.data.data));
    }).catch((err: Error | AxiosError) => {
      setIsLoading(false);
      if (axios.isAxiosError(err)) {
        if (err?.response?.status === 401) {
          navigate('/password', {replace: true, state: {id}})
        } else {
          navigate('/error', {replace: true, state: {code: err.response?.status}})
        }
      }
    });

  }, []);

  return (
    <PlayerConfigContext.Provider value={{ data, isLoading }}>
      {children}
    </PlayerConfigContext.Provider>
  );
};
